<template>
    <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path d="M0 0h40v40H0z"/>
            <path d="M17.5 17a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 1 1-5 0v-8a2.5 2.5 0 0 1 2.5-2.5zm0-7a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z" fill="#033D89" fill-rule="nonzero"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconInfoActive',
};
</script>
